import { config } from "../env";
import {
  Delete,
  get,
  patch,
  post,
  postFileUpload,
} from "./helpers/http-handler";

// upload
export const adminImportCountriesListManagement = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/location-management/import/countries`,
    payload
  );

export const adminImportStatesListManagement = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/location-management/import/states`,
    payload
  );

export const adminImportCitiesListManagement = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/location-management/import/cities`,
    payload
  );

// get
export const adminGetCountriesListManagement = () =>
  get(`${config.API_URL}/location-management/list/countries`);
// get(`${config.API_URL}/location-management/admin/list/countries`);

export const adminGetStatesListManagement = (countryId: any) =>
  get(`${config.API_URL}/location-management/list/states?country=${countryId}`);
// get(
//   `${config.API_URL}/location-management/admin/list/states?country=${countryId}`
// );

export const adminImportListManagement = (payload: object) =>
  postFileUpload(`${config.API_URL}/legislation/import/data`, payload);

export const adminGetStatesListManagementString = (countryId: any) =>
  get(`${config.API_URL}/location-management/list/states?${countryId}`);
// get(`${config.API_URL}/location-management/admin/list/states?${countryId}`);

export const adminGetCitiesListManagement = (stateId: number) =>
  // get(`${config.API_URL}/location-management/list/cities?state=${stateId}`);
  get(`${config.API_URL}/location-management/list/cities?state=${stateId}`);
export const GetCountriesListManagement = () =>
  get(`${config.API_URL}/location-management/list/countries`);
// get(`${config.API_URL}/location-management/admin/list/countries`);

export const GetStatesListManagement = (countryId: number) =>
  get(
    `${config.API_URL}/location-management/list/states?countryId=${countryId}`
  );
// get(
//   `${config.API_URL}/location-management/admin/list/states?country=${countryId}`
// );

export const GetCitiesListManagement = (stateId: number) =>
  get(`${config.API_URL}/location-management/list/cities?stateId=${stateId}`);
// get(
//   `${config.API_URL}/location-management/admin/list/cities?state=${stateId}`
// );

export const adminGetListManagementGroupCode = (groupCode: string) =>
  get(`${config.API_URL}/list-management/list/${groupCode}`);

export const adminCreateListManagementStateCategoryListNew = (
  payload: object
) => post(`${config.API_URL}/masters/state-category-of-law`, payload);

export const adminGetListManagementGroup = (groupCode: string) =>
  get(`${config.API_URL}/list-management/list/${groupCode}`);

// attach category to state
export const adminGetListManagementStateCategoryList = (stateId: string) =>
  get(`${config.ADMIN_URL}/state-category-of-law?state_id=${stateId}`);
export const adminGetListManagementStateCategoryListByQuery = (
  stateId: string
) => get(`${config.API_URL}/masters/state-category-of-law?${stateId}`);
export const adminGetcheckpointListManagementStateCategoryList = (
  stateId: string
) => get(`${config.API_URL}/masters/state-category-of-law?state_id=${stateId}`);
export const adminGetcheckpointListManagementStateLegislationList = (
  stateId: string
) => get(`${config.API_URL}/masters/legislation?state_id=${stateId}`);

export const adminGetcheckpointListManagementStateLegislationRuleList = (
  legislation_id: string
) =>
  get(
    `${config.API_URL}/masters/legislation-rule?legislation_id=${legislation_id}`
  );

export const adminCreateListManagementStateCategoryList = (payload: object) =>
  post(`${config.ADMIN_URL}/state-category-of-law`, payload);

// group

export const adminListManagementCreateGroup = (payload: object) =>
  post(`${config.API_URL}/list-management/groups`, payload);

export const adminListManagementGetGroups = () =>
  get(`${config.API_URL}/list-management/groups`);

export const adminListManagementPatchGroup = (id: string, payload: object) =>
  patch(`${config.API_URL}/list-management/groups/${id}`, payload);

export const adminListManagementDeleteGroup = (id: string) =>
  Delete(`${config.API_URL}/list-management/groups/${id}`);

// group items

export const adminListManagementCreateGroupItems = (
  groupId: string,
  payload: object
) => post(`${config.API_URL}/list-management/groups/${groupId}/items`, payload);

export const adminListManagementGetGroupsItems = (groupId: string) =>
  get(`${config.API_URL}/list-management/groups/${groupId}/items`);

export const adminListManagementPatchGroupItems = (
  groupId: string,
  itemId: string,
  payload: object
) =>
  patch(
    `${config.API_URL}/list-management/groups/${groupId}/items/${itemId}`,
    payload
  );

export const adminListManagementDeleteGroupItems = (
  groupId: string,
  itemId: string
) =>
  Delete(`${config.API_URL}/list-management/groups/${groupId}/items/${itemId}`);

// legislation

export const adminCreateLegislationManagement = (payload: object) =>
  post(`${config.API_URL}/masters/legislation`, payload);

export const adminGetLegislationManagement = (stateId: string) =>
  get(`${config.ADMIN_URL}/legislation?state_id=${stateId}`);
export const adminGetLegislationManagementByQuery = (stateId: string) =>
  get(`${config.API_URL}/masters/legislation?${stateId}`);

export const adminGetSpecificLegislationManagement = (id: string) =>
  get(`${config.API_URL}/legislation-management/legislation/${id}`);

export const adminUpdateSpecificLegislationManagement = (
  id: string,
  payload: object
) =>
  patch(`${config.API_URL}/legislation-management/legislation/${id}`, payload);

export const adminDeleteSpecificLegislationManagement = (id: string) =>
  Delete(`${config.API_URL}/legislation-management/legislation/${id}`);

// legislation-rule

export const adminCreateLegislationManagementRule = (payload: object) =>
  post(`${config.API_URL}/masters/legislation-rule`, payload);

export const adminGetLegislationManagementRule = (legislation_id: string) =>
  get(
    `${config.API_URL}/masters/legislation-rule?legislation_id=${legislation_id}`
  );
export const adminGetLegislationManagementRuleByQuery = (
  legislation_id: string
) => get(`${config.ADMIN_URL}/legislation-rule?${legislation_id}`);

export const adminGetSpecificLegislationManagementRule = (id: string) =>
  get(`${config.API_URL}/legislation-management/legislation-rule/${id}`);

export const adminUpdateSpecificLegislationManagementRule = (
  id: string,
  payload: object
) =>
  patch(
    `${config.API_URL}/legislation-management/legislation-rule/${id}`,
    payload
  );

export const adminDeleteSpecificLegislationManagementRule = (id: string) =>
  Delete(`${config.API_URL}/legislation-management/legislation-rule/${id}`);

//smart filters updated APIs

export const getSmartFilterCategoryOfLawList = (queryRequest: string) =>
  get(`${config.API_URL}/masters/state-category-of-law?${queryRequest}`);

export const getSmartFilterLegislationList = (queryRequest: string) =>
  get(`${config.API_URL}/masters/legislation?${queryRequest}`);

export const getSmartFilterLegislationRuleList = (queryRequest: string) =>
  get(`${config.API_URL}/masters/legislation-rule?${queryRequest}`);

export const getSmartFilterListManagementList = (queryRequest: string) =>
  get(`${config.API_URL}/list-management/list-item?${queryRequest}`);

export const exportLegislation = (queryRequest: string) =>
  get(`${config.API_URL}/masters/legislation/export/data?${queryRequest}`);

export const exportLegislationRule = (queryRequest: string) =>
  get(`${config.API_URL}/masters/legislation-rule/export/data?${queryRequest}`);

// New Filter Api Self Compliance
export const adminGetSCCountriesListManagement = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/filters/countries?${queryRequest}`
  );

export const adminGetSCStatesListManagement = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance-task/filters/states?${queryRequest}`);

export const getSmartFilterSCCategoryOfLawList = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/filters/state-category-of-law?${queryRequest}`
  );

export const getSmartFilterSCLegislationList = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/filters/legislation?${queryRequest}`
  );

export const getSmartFilterSCLegislationRuleList = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/filters/legislation-rule?${queryRequest}`
  );

// New Filter Api Repository Checkpoint Master
export const adminGetCheckpointCountriesListManagement = (
  queryRequest: string
) => get(`${config.API_URL}/checkpoint/filters/countries?${queryRequest}`);

export const adminGetCheckpointStatesListManagement = (queryRequest: string) =>
  get(`${config.API_URL}/checkpoint/filters/states?${queryRequest}`);

export const getSmartFilterCheckpointCategoryOfLawList = (
  queryRequest: string
) =>
  get(
    `${config.API_URL}/checkpoint/filters/state-category-of-law?${queryRequest}`
  );

export const getSmartFilterCheckpointLegislationList = (queryRequest: string) =>
  get(`${config.API_URL}/checkpoint/filters/legislation?${queryRequest}`);

export const getSmartFilterCheckpointLegislationRuleList = (
  queryRequest: string
) =>
  get(`${config.API_URL}/checkpoint/filters/legislation-rule?${queryRequest}`);

export const getSmartFilterCheckpointEvent = (queryRequest: string) =>
  get(`${config.API_URL}/checkpoint/filters/events?${queryRequest}`);

export const getSmartFilterCheckpointSubEvent = (queryRequest: string) =>
  get(`${config.API_URL}/checkpoint/filters/sub-events?${queryRequest}`);

//New Filter API for Checkpoint > Assigned Task
// get
export const adminGetATCountriesListManagement = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance/filters/countries?${queryRequest}`);

export const adminGetATStatesListManagement = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance/filters/states?${queryRequest}`);

export const getSmartFilterATCategoryOfLawList = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance/filters/state-category-of-law?${queryRequest}`
  );

export const getSmartFilterATLegislationList = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance/filters/legislation?${queryRequest}`);

export const getSmartFilterATLegislationRuleList = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance/filters/legislation-rule?${queryRequest}`
  );

//New Filter API for Internal Compliance
//get
export const adminGetICCountriesListManagement = () =>
  get(`${config.API_URL}/internal-compliance-task/filters/countries`);

export const adminGetICStatesListManagement = (countryId: any) =>
  get(
    `${config.API_URL}/internal-compliance-task/filters/states?country=${countryId}`
  );

export const exportCheckpointLicense = (payload: object) =>
  post(`${config.API_URL}/reports/license-task`, payload);
